import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ExporterColumn } from '@webapp/models'

export const ExporterColumnMock = Factory.Sync.makeFactory<ExporterColumn>({
  key: Factory.each(() => faker.lorem.words(2)),
  header: Factory.each(() => faker.lorem.words(2)),
  active: true,
})
